import { render, staticRenderFns } from "./SubNavV2.vue?vue&type=template&id=2e1ef489&scoped=true"
import script from "./SubNavV2.vue?vue&type=script&lang=js"
export * from "./SubNavV2.vue?vue&type=script&lang=js"
import style0 from "./SubNavV2.vue?vue&type=style&index=0&id=2e1ef489&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1ef489",
  null
  
)

export default component.exports